<template>
  <Card>
    <div class="cardTitle">
      {{ cardTitle ? $t(cardTitle) : cardTitle }} <span v-if="categories.length > 0">({{ categories.length }})</span>
    </div>
    <div class="categoriesListNotSelected" v-if="categories.length <= 0">{{ $t('Категории не выбраны') }}</div>
    <DataTableVirtual
      v-else
      :headers="headers"
      :items="categories"
      fixed-header
      disable-sort
      class="categoriesList"
      :class="{'categoriesListOverflow' : categories.length > 5}"
    >
      <template v-slot:item.name="{ item }">
        <div class="categoriesListItemName">{{ item.name }}</div>
      </template>
    </DataTableVirtual>
  </Card>
</template>

<script>
import Card from '@intec/vue-components/form/Card.vue';
import DataTableVirtual from "@intec/vue-components/table/DataTableVirtual.vue"

export default {
  name: 'CategoriesView',
  components: { Card, DataTableVirtual },
  props: {
    cardTitle: { 
      type: String
    },
    categories: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          title: 'Наименование',
          key: 'name'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.v-data-table) {
  th {
    background-color: rgb(var(--grey-3)) !important;
    .v-data-table-header__content {
      font-family: 'Manrope';
      font-weight: 500;
      font-size: 16px;
      color: rgb(var(--black-color));
    }
  }
  .v-table__wrapper > table > tbody > tr:not(:first-child, :last-child) > td {
    padding: 12px;
  }
}

.categoriesList {
  border: none;

  &Overflow {
    max-height: 320px;
  }

  &ItemName, &NotSelected {
    font-family: 'Manrope';
    font-weight: 400;
    font-size: 16px;
    color: rgb(var(--black-color));
  }
}
</style>
